export var TipoAreaEnum;
(function (TipoAreaEnum) {
    TipoAreaEnum["Todos"] = "TODOS";
    TipoAreaEnum["Gleba"] = "GLEBA";
    TipoAreaEnum["Assentamento"] = "ASSENTAMENTO";
    TipoAreaEnum["Individual"] = "INDIVIDUAL";
})(TipoAreaEnum || (TipoAreaEnum = {}));
(function (TipoAreaEnum) {
    var mapDescricao = new Map([
        [TipoAreaEnum.Todos, 'Todos'],
        [TipoAreaEnum.Gleba, 'Gleba'],
        [TipoAreaEnum.Assentamento, 'Assentamento'],
        [TipoAreaEnum.Individual, 'Individual'],
    ]);
    function getDescricao(key) {
        if (key === undefined || key === null) {
            return 'Desconhecido';
        }
        return mapDescricao.get(key);
    }
    TipoAreaEnum.getDescricao = getDescricao;
    function getOptions() {
        var list = [];
        mapDescricao.forEach(function (label, value) {
            list.push({ label: label, value: value });
        });
        return list;
    }
    TipoAreaEnum.getOptions = getOptions;
    function getTipoAreaEnumKey(value) {
        var entry = Object.entries(TipoAreaEnum).find(function (_a) {
            var _ = _a[0], v = _a[1];
            return v === value;
        });
        return entry ? entry[1] : null;
    }
    TipoAreaEnum.getTipoAreaEnumKey = getTipoAreaEnumKey;
})(TipoAreaEnum || (TipoAreaEnum = {}));
